
/**@author Lupita Llamas
 * Clase modelo de la pregunta para manejarla en front
 */
export class QuestionBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  controlType: string;

  constructor(options: {
    value?: T,
    key?: string,
    label?: string,
    required?: boolean,
    controlType?: string;
  } = {}) {
    this.value = options.value;
    this.key = options.key;
    this.label = options.label;
    this.required = !!options.required;
    this.controlType = options.controlType || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/question-base.ts